import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import withReduxProvider from "web/react/redux-provider";
import { openEmailCaptureOverlay } from "web/redux/ducks/email-capture-overlay";
import PrimaryButton from "web/react/components/buttons/primary-button/primary-button";
import SecondaryButton from "web/react/components/buttons/secondary-button/secondary-button";
import { gettext } from "web/script/modules/django-i18n";
import LeadLink from "web/react/components/lead-link/lead-link";
import environment from "web/script/modules/environment";
import userProfiler from "web/script/modules/userprofiler";
import SVGIcon from "../svg-icon/svg-icon";

export function BuyOnStoreButton({
    leadUrl,
    leadLabel,
    openEmailCaptureOverlay,
    productId,
    reason,
    isExpressCheckout,
}) {
    function onClickBuyNow() {
        if (!userProfiler.isLoggedIn() && environment.get("boomLeadSignupPrompt")) {
            openEmailCaptureOverlay({
                productId: productId,
                captureType: "signup_lead_save",
            });
        }
    }
    let button;

    if (isExpressCheckout) {
        button = (
            <SecondaryButton fullHeight fullWidth element="span">
                <SVGIcon name="hyperlink" /> {gettext("product.buy_area.buy_direct_btn_text")}
            </SecondaryButton>
        );
    } else {
        button = (
            <PrimaryButton fullHeight fullWidth element="span">
                {leadLabel}
            </PrimaryButton>
        );
    }

    return (
        <LeadLink
            afterOnClick={onClickBuyNow}
            href={leadUrl}
            openInNewTab={true}
            productId={productId}
            reason={reason}
        >
            {button}
        </LeadLink>
    );
}

BuyOnStoreButton.propTypes = {
    leadLabel: PropTypes.string,
    leadUrl: PropTypes.string.isRequired,
    openEmailCaptureOverlay: PropTypes.func,
    productId: PropTypes.string.isRequired,
    reason: PropTypes.string,
    isExpressCheckout: PropTypes.bool,
};

BuyOnStoreButton.defaultProps = {
    leadLabel: gettext("product.buy_area.shop_now"),
    reason: "buy-on-store-button",
};

export default withReduxProvider(
    connect(
        null,
        { openEmailCaptureOverlay }
    )(BuyOnStoreButton)
);
